import { Badge, Button, Checkbox, Flashbar, FlashbarProps, FormField, Grid, Input, KeyValuePairs, Link, Select, SelectProps, Spinner, SplitPanel, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { formatRut, validateRut } from '@fdograph/rut-utilities';
import { mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import { format } from 'date-fns';
import Copy from '../../../../../components/Copy';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';

const pageSize = 20;
type OptionDefinition = SelectProps.Option & {
    /** Custom column 1: Descriptive identifier for internal sorting or grouping. */
    comuna?: string;
    direccion?: string;
    giro?: string;
};
export const OPSFuelInvoicePage = () => {
    const { menu, parameters } = useGlobalState();

    const [userMessagesInvoicing, setUserMessagesInvoicing] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [rutLoading, setRutLoading] = useState<boolean>(false);

    const [checkInvoice, setCheckInvoice] = useState(false);
    const [invoiceReady, setInvoiceReady] = useState(false);
    const [invoiceReadyPre, setInvoiceReadyPre] = useState(false);
    const [dte, setDte] = useState<any>();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    const [movement, setMovement] = useState<ItemsMovement>();
    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [movementsAll, setMovementsAll] = useState<ItemsMovement[]>([]);

    const [RUT, setRUT] = useState("");
    const [razonSocial, setRazonSocial] = useState("");


    const [siiSucursales, setSiiSucursales] = React.useState<OptionDefinition[]>([]);
    const [siiSucursal, setSiiSucursal] = React.useState<OptionDefinition>();


    const [siiGiros, setSiiGiros] = React.useState<OptionDefinition[]>([]);
    const [siiGiro, setSiiGiro] = React.useState<OptionDefinition>();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        setMovements(movementsAll)
    }, [parameters.startDate, parameters.endDate]);

    useEffect(() => {
        let check = true;
        if (!RUT) check = false;
        if (!validateRut(RUT)) check = false;
        if (!siiGiro) check = false;
        if (!siiSucursal) check = false;
        if (!checkInvoice) check = false;
        setInvoiceReady(check);
        let check2 = false;
        if (!RUT) check2 = true;
        if (!validateRut(RUT)) check2 = true;
        if (!siiGiro) check2 = true;
        if (!siiSucursal) check2 = true;
        setInvoiceReadyPre(check2);
    }, [siiGiro, siiSucursal, checkInvoice, RUT]);

    useEffect(() => {
        handleCheckFuel();
    }, [parameters.startDate, parameters.endDate]);

    const handleMovementClick = async (rowData: ItemsMovement) => {
        if ((rowData.jsonDocuments.hasOwnProperty("number") && rowData.ammount < 0 && rowData.jsonDocuments.number === 0) || rowData.jsonDocuments.number !== 0) {
            setSiiSucursal(undefined)
            setSiiGiro(undefined)
            setCheckInvoice(false)
            setRUT("");
            setMovement(rowData)
            let IVA = Math.round(rowData.jsonDocuments.lines[0].subTotal - (rowData.jsonDocuments.lines[0].subTotal / 1.19));
            let tDte = {
                Encabezado: {
                    IdDoc: {
                        TipoDTE: 33,
                        Folio: 0,
                        FchEmis: format(new Date(), 'yyyy-MM-dd'),
                        TpoTranVenta: 1,
                        TpoTranCompra: 1,
                        FmaPago: 1,
                        MntBruto: 1
                    },
                    Emisor: {
                        RUTEmisor: "65289080-6",
                        RznSoc: "CLUB DE PLANEADORES DE VITACURA",
                        GiroEmis: "VENTA AL POR MAYOR DE COMBUSTIBLES SOLIDOS, LIQUIDOS Y GASEOSOS Y PROD",
                        Acteco: 466100,
                        DirOrigen: "AV SANTA MARIA 6299",
                        CmnaOrigen: "VITACURA",
                        Telefono: "222420836",
                        CdgSIISucur: "64711751"
                    },
                    Totales: {
                        MntNeto: rowData.jsonDocuments.lines[0].subTotal - IVA,
                        TasaIVA: "19",
                        IVA: IVA,
                        MntTotal: rowData.jsonDocuments.lines[0].subTotal
                    },
                    Receptor: {
                        RUTRecep: rowData.jsonSII.rut,
                        RznSocRecep: rowData.jsonSII.razonSocial,
                        GiroRecep: "",
                        DirRecep: "",
                        CmnaRecep: ""
                    }
                },
                Detalle: [
                    {
                        NroLinDet: 1,
                        NmbItem: rowData.jsonDocuments.lines[0].product,
                        QtyItem: rowData.jsonDocuments.lines[0].qty,
                        PrcItem: rowData.jsonDocuments.lines[0].price,
                        MontoItem: rowData.jsonDocuments.lines[0].subTotal
                    }
                ]
            }
            //if (rowData.jsonSII.rut)
            /*
            
            if (rowData.jsonSII.razonSocial)
                setRazonSocial(rowData.jsonSII.razonSocial)
            if (rowData.jsonSII.sucursales) {
                const mapped = rowData.jsonSII.sucursales.map((item: { comuna: any; direccion: any; cdgSIISucur: any; }) => ({
                    label: `${item.comuna} - ${item.direccion}`,
                    value: `${item.cdgSIISucur}`,
                    direccion: item.direccion,
                    comuna: item.comuna
                }));
                if (mapped.length === 1) {
                    setSiiSucursal(mapped[0])
                    tDte.Encabezado.Receptor.CmnaRecep = mapped[0].comuna;
                    tDte.Encabezado.Receptor.DirRecep = mapped[0].direccion;
                } else {
                    tDte.Encabezado.Receptor.CmnaRecep = ""
                    tDte.Encabezado.Receptor.DirRecep = "";
                }
                setSiiSucursales(mapped)
            }
            if (rowData.jsonSII.actividades) {
                const mapped = rowData.jsonSII.actividades.map((item: { actividadEconomica: any; codigoActividadEconomica: any; }) => ({
                    label: `${item.actividadEconomica}`,
                    value: `${item.codigoActividadEconomica}`
                }));
                if (mapped.length === 0)
                    mapped.push({ label: "No informado", value: "No informado" })
                if (mapped.length === 1) {
                    setSiiGiro(mapped[0])
                    tDte.Encabezado.Receptor.GiroRecep = mapped[0].label;
                } else {
                    tDte.Encabezado.Receptor.GiroRecep = ""
                }


                setSiiGiros(mapped)
                //console.log(mapped)
            }
            */
            setDte(tDte)

            if (rowData.jsonDocuments.RUT) {

                setMovement(prev => {
                    if (!prev) return undefined;
                    return { ...prev, jsonDocuments: { ...prev.jsonDocuments, RUT: rowData.jsonDocuments.RUT } };
                });
                setRUT(rowData.jsonDocuments.RUT)
            }
        }
    }
    useEffect(() => {
        if (RUT && validateRut(RUT)) {
            handleSII(formatRut(RUT))
        }
    }, [RUT])
    const handleRUTBlur = () => {
        if (validateRut(movement.jsonDocuments.RUT) || movement.jsonDocuments.RUT === "55555555-5") {
            setRUT(formatRut(movement.jsonDocuments.RUT))
            handleSII(formatRut(movement.jsonDocuments.RUT))
        }
    }
    const handleSII = async (RUT: string) => {

        try {
            setRutLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/haulmer/taxpayer',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    RUT: formatRut(RUT),
                }),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            let tDte = dte;
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                if (data.SII.razonSocial) {
                    setRazonSocial(data.SII.razonSocial)
                    setMovement(prev => {
                        if (!prev) return undefined;
                        tDte.Encabezado.Receptor.RUTRecep = data.SII.rut;
                        tDte.Encabezado.Receptor.RznSocRecep = data.SII.razonSocial;
                        return { ...prev, jsonSII: { ...prev.jsonSII, RUT: data.SII.rut, razonSocial: data.SII.razonSocial } };
                    });
                }
                if (data.SII.actividades) {
                    const mapped = data.SII.actividades.map((item: { actividadEconomica: any; codigoActividadEconomica: any; }) => ({
                        label: `${item.actividadEconomica}`,
                        value: `${item.codigoActividadEconomica}`
                    }));
                    setSiiGiro(undefined)
                    setSiiGiros(mapped)
                    if (mapped.length === 1) {
                        setSiiGiro(mapped[0])
                        tDte.Encabezado.Receptor.GiroRecep = mapped[0].label;
                    } else {
                        tDte.Encabezado.Receptor.GiroRecep = ""
                    }

                }
                if (data.SII.sucursales) {
                    ////console.log(data.SII.sucursales)
                    const mapped = data.SII.sucursales.map((item: { comuna: any; direccion: any; cdgSIISucur: any; }) => ({
                        label: `${item.comuna} - ${item.direccion}`,
                        value: `${item.cdgSIISucur}`,
                        direccion: item.direccion,
                        comuna: item.comuna
                    }));
                    setSiiSucursal(undefined)
                    setSiiSucursales(mapped)
                    if (mapped.length === 1) {
                        setSiiSucursal(mapped[0])
                        tDte.Encabezado.Receptor.CmnaRecep = mapped[0].comuna;
                        tDte.Encabezado.Receptor.DirRecep = mapped[0].direccion;
                    } else {
                        tDte.Encabezado.Receptor.CmnaRecep = ""
                        tDte.Encabezado.Receptor.DirRecep = "";
                    }

                }
                setDte(tDte)
            }
        } catch (error: any) {
            //console.log(error)
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setRutLoading(false) }
    }
    const handleInvoice = async () => {
        try {
            setLoading(true)
            let body = {
                idMovement: movement?.idMovement,
                idEquipment: movement?.idEquipment,
                idUser: movement?.idUser,
                SII: { dte: dte, response: ["XML", "PDF", "80MM", "FOLIO"] },
                production: getUrlVersion().includes("app.") ? true : false,
                callback: {
                    isFuel: true,
                    isFuelInvoiced: 0,
                    orderBy: "dateTransaction",
                    movementType: "-1",
                    order: "desc",
                    columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK,jsonSII,idEquipment"
                }
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/haulmer/issue',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),

            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setRUT("");
                setMovement(undefined);
                if (data.movements) {
                    const filtered = data.movements.filter(
                        (item: any) => item.jsonDocuments?.hasOwnProperty("number") && item.jsonDocuments.number === 0
                    );
                    setMovements(filtered)
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false);

        }
    }
    const handleCheckFuel = async () => {
        setFilterValue("")
        try {
            setMovement(undefined);
            setRUT("");
            setLoading(true)
            //
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    isFuel: true,
                    isFuelInvoiced: 0,
                    movementType: "-1",
                    orderBy: "dateTransaction",
                    order: "desc",
                    columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK,jsonSII,idEquipment"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                const filtered = data.movements.filter(
                    (item: any) => item.jsonDocuments?.hasOwnProperty("number") && item.jsonDocuments.number === 0
                );
                setMovements(filtered)
                ////console.log(filtered)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const filtered: ItemsMovement[] = movements.filter((item) => {
        const normalize = (str: string | undefined | null) =>
            (str || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.data, item.RUT, item.ammount, item.displayName, , item.registration, , item.data].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });

    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={movement !== undefined ? true : false}
            onSplitPanelToggle={({ detail }) => {
                if (detail.open) {
                    null
                } else {
                    setMovement(undefined);
                    setRUT("");
                }
            }}
            splitPanel={
                <SplitPanel hidePreferencesButton closeBehavior='hide'
                    header={`Facturar movimiento #${movement?.idMovement}`}
                    headerActions={<Copy variant="icon" value={movement?.idMovement.toString()} />}
                >
                    <SpaceBetween direction="vertical" size="xs">
                        {movement && (
                            <>
                                <Flashbar items={userMessagesInvoicing} />
                                <Grid
                                    gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}
                                >
                                    <div><FormField label="RUT">
                                        <Input value={movement.jsonDocuments.RUT ?? ""} autoComplete={false} onChange={(event) => {
                                            let rut: any = validateRut(event.detail.value) ? formatRut(event.detail.value) : event.detail.value;
                                            rut = event.detail.value;


                                            setMovement(prev => {
                                                if (!prev) return undefined;
                                                return { ...prev, jsonDocuments: { ...prev.jsonDocuments, RUT: rut } };
                                            });
                                            if (validateRut(event.detail.value) && RUT !== event.detail.value) {
                                                ////console.log("setRUTInput", RUT, event.detail.value, RUT !== event.detail.value)
                                                //setRUT(event.detail.value)
                                            }
                                        }} onBlur={() => {
                                            if (validateRut(movement.jsonDocuments.RUT)) {
                                                setRUT(formatRut(movement.jsonDocuments.RUT))
                                                setMovement(prev => {
                                                    if (!prev) return undefined;
                                                    return { ...prev, jsonDocuments: { ...prev.jsonDocuments, RUT: formatRut(movement.jsonDocuments.RUT) } };
                                                });
                                            }
                                            //handleRUTBlur()
                                        }} />
                                    </FormField></div>
                                    <div><FormField label="Razón social" info={
                                        rutLoading ? <Spinner size="normal" /> : null
                                    }>
                                        <Input value={razonSocial} autoComplete={false} readOnly />
                                    </FormField></div>
                                </Grid>
                                <Grid
                                    gridDefinition={[{ colspan: 12 }]}
                                >
                                    <div><FormField label="Giro">
                                        <Select
                                            expandToViewport
                                            selectedOption={siiGiro || { value: "No informado", label: "No informado" }}
                                            onChange={({ detail }) => {
                                                setSiiGiro(detail.selectedOption)

                                                let tDte = dte;
                                                dte.Encabezado.Receptor.GiroRecep = detail.selectedOption.label;
                                                setDte(tDte)
                                                setMovement(prev => {
                                                    if (!prev) return undefined;
                                                    return { ...prev, jsonSII: { ...prev.jsonSII, actividadEconomica: detail.selectedOption.label, codigoActividadEconomica: Number(detail.selectedOption.value), giro: detail.selectedOption.label } };
                                                });
                                            }}
                                            options={siiGiros}
                                        />

                                    </FormField></div>
                                </Grid>
                                <Grid
                                    gridDefinition={[{ colspan: 12 }]}
                                >
                                    <div><FormField label="Sucursal">
                                        <Select
                                            expandToViewport
                                            selectedOption={siiSucursal || null}
                                            onChange={({ detail }) => {
                                                setSiiSucursal(detail.selectedOption)
                                                let tDte = dte;
                                                const selectedOption = detail.selectedOption as OptionDefinition;
                                                dte.Encabezado.Receptor.CmnaRecep = selectedOption.comuna;
                                                dte.Encabezado.Receptor.DirRecep = selectedOption.direccion;
                                                setDte(tDte)

                                                setMovement(prev => {
                                                    if (!prev) return undefined;
                                                    return { ...prev, jsonSII: { ...prev.jsonSII, direccion: detail.selectedOption.label, cdgSIISucur: Number(detail.selectedOption.value) } };
                                                });
                                            }}
                                            options={siiSucursales}
                                        />

                                    </FormField></div>
                                </Grid>
                                <KeyValuePairs
                                    columns={1}
                                    items={movement?.jsonDocuments.lines.map((line: { qty: any; price: { toLocaleString: () => any; }; subTotal: { toLocaleString: () => any; }; product: any; }, index: number) => ({
                                        label: `Producto #${index + 1}`,
                                        value: `${line.product}`
                                    }))}
                                />
                                <Checkbox checked={checkInvoice} disabled={invoiceReadyPre} onChange={(event) => setCheckInvoice(event.detail.checked)}>
                                    Confirmo que la información es correcta para emitir la factura
                                </Checkbox>
                                <Box textAlign='right'>
                                    <Button disabled={invoiceReady == false} onClick={() => handleInvoice()} variant='primary'>Emitir</Button>
                                </Box>
                            </>
                        )}
                    </SpaceBetween>
                </SplitPanel>
                //onChange={(event) => setRUT(event.detail.value.toUpperCase())} onBlur={() => handleRUTBlur()}
            }
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Movimientos sin facturar
                        </Header>


                        <SpaceBetween direction='vertical' size='xs'>

                            <Table
                                variant="embedded"

                                stickyHeader

                                filter={
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <TextFilter

                                            filteringPlaceholder="Filtrar"
                                            filteringText={filterValue}
                                            onChange={({ detail }) => {
                                                setFilterValue(detail.filteringText);
                                                setCurrentPageIndex(1);
                                            }}
                                        />
                                        <Button style={{ root: btnIconForm }} onClick={handleCheckFuel}><Icon path={mdiRefresh} size={1} /></Button>
                                    </SpaceBetween>
                                }
                                pagination={
                                    filtered.length > pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )
                                }
                                columnDefinitions={[
                                    {
                                        id: "dateTransaction",
                                        header: "Fecha",
                                        cell: item => (
                                            <FormField
                                                label={<Link onClick={() => { handleMovementClick(item) }}>{item.dateTransaction}</Link>}
                                                description={<><span>{item.idMovement}</span></>}
                                            />
                                        ),
                                        width: 120
                                    },
                                    {
                                        id: "idUser",
                                        header: "Usuario",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    item.jsonMovement.registration :
                                                    <Badge color='red'>Anulado</Badge>
                                                }
                                                label={item.displayName}
                                            />
                                        )
                                    },
                                    {
                                        id: "data",
                                        header: "Glosa",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    `${item.jsonMovement.counterEnd} - ${item.jsonMovement.counterStart} = ${item.jsonMovement.liters} LTS x ${item.jsonMovement.price} = ${item.ammount}`
                                                    : "·"}
                                                label={item.data}
                                            />
                                        )
                                    },
                                    {
                                        id: "charge",
                                        header: "Cargo",
                                        cell: item => (
                                            <FormField
                                                description={
                                                    item.ammount < 0 && item.jsonDocuments?.number ? (
                                                        <Badge color="green">{`F${item.jsonDocuments?.number}`}</Badge>
                                                    ) :
                                                        item.ammount < 0 ?
                                                            <Badge color="blue">Pendiente</Badge> : null
                                                }

                                                label={
                                                    (item.ammount < 0 ?
                                                        item.ammount.toLocaleString('es-CL', {
                                                            style: 'currency',
                                                            currency: 'CLP',
                                                            maximumFractionDigits: 2
                                                        }) : "Sin cargo")
                                                }
                                            />
                                        )


                                    },
                                ]}
                                trackBy="idMovement"
                                items={paginated ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin movimientos asociados</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                            />
                        </SpaceBetween>
                    </SpaceBetween>

                </>
            }
        />
    );
};
